import { render, staticRenderFns } from "./window-item-tertiary.vue?vue&type=template&id=e0514c34&scoped=true&"
import script from "./window-item-tertiary.vue?vue&type=script&lang=js&"
export * from "./window-item-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0514c34",
  null
  
)

export default component.exports